import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from '../../../configuration/services';
import { TranslateService } from '@ngx-translate/core';
import { MenuServices } from '../../../menu/services';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ComboCreateDishSelectPage } from '../combo-create-dish-select/combo-create-dish-select';
import { AnalyticsServices } from '../../../services/analyticsServices';


@Component({
  selector: 'page-combo-create-select-template',
  templateUrl: 'combo-create-select-template.html',
})
export class ComboCreateSelectTemplatePage {

  template: any = "";
  update_state: boolean = false;
  combo_uid: any;
  combo_name: any = "";
  new_combo: boolean = false;
  template_array = [
    {
      name: 'rabassa',
      src: './assets/templates/Rabassa.jpg'
    },
    {
      name: 'conor',
      src: './assets/templates/conor.jpg'
    },
    {
      name: 'bh',
      src: './assets/templates/BH.jpg'
    },
    {
      name: 'panther',
      src: './assets/templates/Panther.jpg'
    },
    {
      name: 'torrot',
      src: './assets/templates/torrot.jpg'
    },
    {
      name: 'california',
      src: './assets/templates/California.jpg'
    },
    {
      name: 'santacruz',
      src: './assets/templates/santacruz.jpg'
    },
    {
      name: 'trek',
      src: './assets/templates/trek.jpg'
    },
    {
      name: 'fixie',
      src: './assets/templates/fixie.jpg'
    },
    {
      name: 'bianchi',
      src: './assets/templates/Bianchi.jpg'
    },
    {
      name: 'cervelo2',
      src: './assets/templates/cervelo2.jpg'
    },
    {
      name: 'connondale',
      src: './assets/templates/Connondale.jpg'
    },
    {
      name: 'kona',
      src: './assets/templates/Kona.jpg'
    },
    {
      name: 'megamo',
      src: './assets/templates/megamo.jpg'
    },
    {
      name: 'orbea2',
      src: './assets/templates/orbea2.jpg'
    },
    {
      name: 'pyvot',
      src: './assets/templates/Pyvot.jpg'
    },
    {
      name: 'rockrider',
      src: './assets/templates/rockrider.jpg'
    },
    {
      name: 'scott',
      src: './assets/templates/scott.jpg'
    },
    {
      name: 'specialized',
      src: './assets/templates/specialized.jpg'
    },
    {
      name: 'taicor',
      src: './assets/templates/taicor.jpg'
    },
  ]

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public menuServices: MenuServices,
    public globals: Globals,
    public toastCtrl: ToastController,
    public configurationServices: ConfigurationServices,
    public translate: TranslateService,
    public analyticsServices: AnalyticsServices) {

    //Params
    this.update_state = this.navParams.get('update_state');
    this.combo_uid = this.navParams.get('combo_uid');
    this.template = this.navParams.get('template_name');
    this.combo_name = this.navParams.get('combo_name');
    this.new_combo = this.navParams.get('new_combo');

    if (!this.update_state && this.globals.checkLimitsByLicense('daily_menu', 'templates') == 1) { //Si create y FREE
      this.template = 'conor';
    }

  }

  ionViewWillEnter() {
    if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) {
      this.changeClass();
    }
  }

  changeClass() {
    //Ponemos filtro gris a las plantillas que la version no puede usar
    const template = document.getElementsByClassName('template');
    for (let i = this.globals.checkLimitsByLicense('daily_menu', 'templates'); i < template.length; i++) {
      const slide = template[i] as HTMLElement;
      slide.style.filter = "grayscale(1)";
    }
  }

  select(type) {
    switch (type) {
      case 'rabassa':
        this.template = type;
        break;
      case 'conor':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'bh':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'panther':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'torrot':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'california':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'santacruz':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'trek':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'fixie':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'bianchi':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'cervelo2':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'connondale':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'kona':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'megamo':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'orbea2':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'pyvot':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'rockrider':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'scott':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'specialized':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'taicor':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
    }
  }

  selected() {
    this.template = "";
  }

  checkState(type) {
    if (this.template == type) {
      return true
    } else {
      return false
    }
  }

  async save() {
    if (this.template != '') {
      if (this.update_state) {
        //guardar plantilla y pop
        await this.menuServices.afs.collection('menus').doc(this.combo_uid).update({
          'template_name': this.template,
          'updated_at': new Date(),
        }).then(doc => {
          this.navCtrl.pop();
        });
      } else {
        this.globals.GAtrackView('Combo', 'Combo - Name - Create', this.globals.restaurant.email, 'Create/Update', 'Create name', 'Combo', this.translate.instant('general-titulo-combo'));
        this.menuServices.afs.collection('menus').add({
          'UID_RESTAURANT': this.globals.restaurant_uid,
          'style': 'combo',
          'separator': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/separators%2Fseparador3.png?alt=media&token=1f0e9059-bd6a-49e8-a8e4-18c1e9ec3a11',
          'template': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/templates%2Ffons_mct_blanc.png?alt=media&token=15455e42-1097-4eb0-bb47-1d29ef9622d5',
          'logo_show': true,
          'caption_show': false,
          'enumerate': false,
          'footer_show': true,
          'footer_font_color': '#000',
          'footer_font_family': 'Arial',
          'footer_font_size': '18',
          'footer_text_align': 'center',
          'header_font_color': '#000',
          'header_font_family': 'Arial',
          'header_font_size': '18',
          'header_text_align': 'center',
          'image': '',
          'reference': '',
          'title_es': 'Combo',
          'title_en': 'Combo',
          'title_fr': 'Combo',
          'title_de': 'Combo',
          'title_it': 'Combo',
          'title_ca': 'Combo',
          'subtitle_es': '',
          'subtitle_en': '',
          'subtitle_fr': '',
          'subtitle_it': '',
          'subtitle_de': '',
          'subtitle_ca': '',
          'extra': 0,
          'price': 0,
          'extras_footer': [],
          'sections': this.getsections(),
          'created_at': new Date(),
          'digital_app': true,
          'template_name': this.template,
          'tags': [],
          'tags_static': '',
          'type': 'combo'
        }).then(doc => {
          this.combo_uid = doc.id;
          this.analyticsServices.trackingExp('starter', this.globals.tracking_exp['starter'], '');
          this.analyticsServices.trackingExp('crear combo', this.globals.tracking_exp['create_new_menu'], '');
          this.navCtrl.push(ComboCreateDishSelectPage, {
            type: 'combo',
            section: '0',
            update: this.update_state,
            combo_uid: this.combo_uid,
            combo_name: this.translate.instant('general-nuevo-combo'),
            show_prices: true,
            new_combo: this.new_combo,
          });
        });
      }
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('tutorial-box-menu-selecciona-template'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  getsections() {
    var ret = {
      0: {
        dish: Array(),
        name: 'Todos'
      },
    }
    return ret;
  }

}



// WEBPACK FOOTER //
// ./src/pages/combo/combo-create/combo-create-select-template/combo-create-select-template.ts